import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { B400, N800, N200 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React from 'react';
import { AvatarItemOption, textWrapper } from './AvatarItemOption';
import { HighlightText } from './HighlightText';
import { SizeableAvatar } from './SizeableAvatar';
import { hasValue } from './utils';
export var UserOption = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UserOption, _React$PureComponent);
  var _super = _createSuper(UserOption);
  function UserOption() {
    var _this;
    _classCallCheck(this, UserOption);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getPrimaryText", function () {
      var _this$props$user = _this.props.user,
        name = _this$props$user.name,
        publicName = _this$props$user.publicName,
        highlight = _this$props$user.highlight;
      var result = [jsx("span", {
        key: "name"
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ,
        css: textWrapper(_this.props.isSelected ? "var(--ds-text-selected, ".concat(B400, ")") : "var(--ds-text, ".concat(N800, ")"))
      }, jsx(HighlightText, {
        highlights: highlight && highlight.name
      }, name))];
      if (hasValue(publicName) && name.trim() !== publicName.trim()) {
        result.push(jsx(React.Fragment, {
          key: "publicName"
        }, ' ', jsx("span", {
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          css: textWrapper(_this.props.isSelected ? "var(--ds-text-selected, ".concat(B400, ")") : "var(--ds-text-subtlest, ".concat(N200, ")"))
        }, "(", jsx(HighlightText, {
          highlights: highlight && highlight.publicName
        }, publicName), ")")));
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "renderSecondaryText", function () {
      return _this.props.user.byline ? jsx("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: textWrapper(_this.props.isSelected ? "var(--ds-text-selected, ".concat(B400, ")") : "var(--ds-text-subtlest, ".concat(N200, ")"))
      }, _this.props.user.byline) : undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "renderAvatar", function () {
      var _this$props = _this.props,
        avatarUrl = _this$props.user.avatarUrl,
        status = _this$props.status;
      return jsx(SizeableAvatar, {
        appearance: "big",
        src: avatarUrl,
        presence: status
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getLozengeProps", function () {
      return typeof _this.props.user.lozenge === 'string' ? {
        text: _this.props.user.lozenge
      } : _this.props.user.lozenge;
    });
    return _this;
  }
  _createClass(UserOption, [{
    key: "render",
    value: function render() {
      return jsx(AvatarItemOption, {
        avatar: this.renderAvatar(),
        lozenge: this.getLozengeProps(),
        isDisabled: this.props.user.isDisabled,
        primaryText: this.getPrimaryText(),
        secondaryText: this.renderSecondaryText()
      });
    }
  }]);
  return UserOption;
}(React.PureComponent);